'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _getContrast = require('get-contrast'),
    _getContrast2 = _interopRequireDefault(_getContrast);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getMainShadeIndex = function getMainShadeIndex(palette, backgroundColor) {
  for (var colorIndex = 6, colorIsAccessible = _getContrast2.default.isAccessible(palette[colorIndex], backgroundColor); !colorIsAccessible;) {
    colorIndex++, void 0 === palette[colorIndex] ? (console.warn('Shades #6 and higher in the color palette do not have a high enough contrast ratio against a background color of ' + backgroundColor + '.'), colorIsAccessible = !0) : colorIsAccessible = _getContrast2.default.isAccessible(palette[colorIndex], backgroundColor);
  }

  return Math.min(colorIndex, Object.keys(palette).length - 1);
},
    createColorPalette = function createColorPalette(palette, name) {
  return {
    get name() {
      return name;
    },

    getShade: function getShade(index) {
      return palette[index];
    },
    getMainShade: function getMainShade() {
      var _ref = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          _ref$backgroundColor = _ref.backgroundColor,
          backgroundColor = void 0 === _ref$backgroundColor ? '#ffffff' : _ref$backgroundColor,
          _ref$offset = _ref.offset,
          offset = void 0 === _ref$offset ? 0 : _ref$offset,
          index = void 0;

      return index = '#ffffff' === backgroundColor ? (palette.inflection || getMainShadeIndex(palette, backgroundColor)) + offset : getMainShadeIndex(palette, backgroundColor) + offset, palette[Math.min(index, Object.keys(palette).length - 1)];
    }
  };
};

exports.default = createColorPalette;